export function createQuery(obj: any, exclude?: string, suffix?:string) {
	const qs = Object.keys(obj).map((x) => {
		if (!exclude?.includes(x) && obj[x].length !== 0) {
			return x + '=' + obj[x];
		}
	}).filter((y) => {
		if (y !== undefined) {
			return y;
		}
	}).join('&');

	return suffix ? `${qs}&${suffix}` : qs;
}

export function copyObject(input:any) {
	return JSON.parse(JSON.stringify(input));
}